import React, { useMemo, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import AircraftCardExtraContent from "./AircraftCardExtraContent";

const AircraftCardExpandedContent = React.memo(
    ({ expanded, aircraftData, sharedPage, legId, tripInfo, showMovida, onCollapse }) => {
        // Ref for CSSTransition
        const nodeRef = useRef(null);

        // Memoize the content to prevent unnecessary re-renders
        const content = useMemo(() => {
            if (!expanded || !aircraftData) return null;
            return (
                <AircraftCardExtraContent
                    aircraftData={aircraftData}
                    sharedPage={sharedPage}
                    legId={legId}
                    tripInfo={tripInfo}
                    showMovida={showMovida}
                    onCollapse={onCollapse}
                />
            );
        }, [expanded, aircraftData, sharedPage, legId, tripInfo, showMovida, onCollapse]);

        return (
            <CSSTransition
                in={expanded}
                timeout={{ enter: 300, exit: 600 }}
                classNames="aircraft-card-expanded-content"
                unmountOnExit
                nodeRef={nodeRef}
            >
                <div ref={nodeRef} className="aircraft-card-expanded-content">
                    {content}
                </div>
            </CSSTransition>
        );
    }
);

AircraftCardExpandedContent.displayName = "AircraftCardExpandedContent";

export default AircraftCardExpandedContent;
